import { useMutation, useQueryClient } from 'react-query';

const useSaveCSV = ({
  importQuery,
  queryName,
  onSuccess
}: {
  importQuery: any;
  queryName: string;
  onSuccess?: any;
}) => {
  const queryClient = useQueryClient();
  const saveCSVMutation = useMutation(
    async ({ uuid, ...restCSVProperties }: any): Promise<string> => {
      const data = importQuery(restCSVProperties);
      return data;
    },
    {
      onSuccess: (res) => {
        queryClient.removeQueries('occupant');
        queryClient.removeQueries(queryName);
        if (onSuccess) {
          onSuccess(res);
        }
      }
    }
  );
  return saveCSVMutation;
};

export default useSaveCSV;
